import React from 'react'
import "./ourServeces.css"
import { useMediaQuery } from "react-responsive";
import { MdOutlineMail } from "react-icons/md";
import { MdPhone } from "react-icons/md";

export default function ContactUs() {

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    return (
        <div className='servece-main'>
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <section className='card-servece-contact'>
            <h1 style={{color: '#ffa400'}}>Contact Us</h1>
                    {isDesktopOrLaptop && <span className='contacts'>
                        <div>
                            <h3 style={{ color: 'white' }}><MdOutlineMail/></h3>
                            <h5 style={{ color: 'white', fontSize:15 }}>fxcode.tech@gmail.com</h5>
                        </div>
                    </span>}
                    {isTabletOrMobile && <span className='contacts-mobile'>
                        <div>
                            <h3 style={{ color: 'white' }}><MdOutlineMail/></h3>
                            <h5 style={{ color: 'white', fontSize:15  }}>fxcode.tech@gmail.com</h5>
                        </div>
                    </span>}
                </section>
            </section>
        </div>
    )
}

/*                        <div>
                            <h3 style={{ color: 'white' }}><MdPhone /></h3>
                            <h5 style={{ color: 'white', fontSize:15  }}>+963937460338</h5>
                        </div>*/